import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss'],
})
export class SuccessComponent implements OnInit {

  @Input() message: any;

  constructor(
    private modalController: ModalController
  ) { }

  ngOnInit(): void {
    console.log(this.message)
  }

  dismiss() {
    this.modalController.dismiss();
  }

}
